import { OrderItemRowResolver } from './types'

export const flexoformOrderItemRowResolver: OrderItemRowResolver = item => ({
    name: item.name || 'Флексоформы',
    quantity: item.quantity,
    price: item.approvedPrice,
})
